import PropTypes from 'prop-types';
import { useMemo } from 'react';
import Select, { components } from 'react-select';
import styled from 'styled-components';
import useI18n from '../../lib/useI18n';
import { setActiveCompany } from '../../store';
import { Option } from '../common/form';

export const CompaniesSelector = ({ selectedCompany, companies }) => {
  const { translate } = useI18n('top_bar.companies_selector');
  const options = useMemo(
    () =>
      companies
        .map((company) => ({ label: company.name, value: company.id }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [companies]
  );

  return (
    <Select
      id="topBar-dropdown-companies"
      styles={styles}
      noOptionsMessage={() => translate('.no_options')}
      components={{ DropdownIndicator, Option }}
      options={options}
      defaultValue={{
        label: selectedCompany.name,
        value: selectedCompany.id,
      }}
      inputId="topBar-dropdown-companies-input"
      onChange={handleChange}
    />
  );
};

CompaniesSelector.propTypes = {
  selectedCompany: PropTypes.object.isRequired,
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const StyledIcon = styled.span`
  padding: 0px;
`;

const styles = {
  control: (styles) => ({
    ...styles,
    borderStyle: 'none',
    backgroundColor: 'none',
  }),
  indicatorSeparator: () => ({}),
  singleValue: (styles) => ({
    ...styles,
    color: 'white',
    fontSize: '16px',
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: '2px 4px',
    minWidth: '150px',
    maxWidth: '380px',
  }),
  input: (styles) => ({
    ...styles,
    color: 'white',
    'input[type=text]': {
      boxShadow: 'none',
    },
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    padding: '0px',
  }),
  menuList: (styles) => ({
    ...styles,
    color: 'black',
  }),
};

const CaretDownIcon = () => {
  return (
    <StyledIcon className="material-symbols-outlined">
      arrow_drop_down
    </StyledIcon>
  );
};

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <CaretDownIcon />
  </components.DropdownIndicator>
);

const handleChange = async (option) => {
  try {
    await setActiveCompany(option.value);
    window.location.reload();
  } catch (e) {
    Flash.alert(e.response?.data?.error);
  }
};
